module.exports = "./images/19_shopvise.jpg";